<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="text"
    item-value="inspCat"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
    @change="onChange"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'InspCat2Input',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    isStartUp: {
      // 入力された値のis_start_upフラグと同じフラグのinspCat2を表示
      // 制限しない場合はNull
      type: Boolean,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  watch: {
    async isStartUp() {
      await this.setItems(this.isStartUp)
    },
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0117')
      },
    },
  },

  methods: {
    onChange(value) {
      let itemDetail = this.items.find((item) => item.inspCat == value)
      this.$emit('change', itemDetail)
    },
    async setItems(isStartUp) {
      try {
        this.loading = true
        let params = {
          validOnly: this.validOnly,
        }
        this.items = await API.get('/master/inspCats/cat2', params)
        this.items.forEach((element) => {
          element['text'] = element['inspCat'] + ' : ' + element['inspCatName']
        })
        if (isStartUp != null) {
          this.items = this.items.filter((e) => e.isStartUp == isStartUp)
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0117') })))
      } finally {
        this.loading = false
      }
    },
  },

  async mounted() {
    await this.setItems(this.isStartUp)
  },
}
</script>
